import React, { FC } from 'react';
import { ClassifierBreadcrumbs } from '../ClassifierBreadcrumbs';
import { useClassifierFormCodeAndNameValues } from './useClassifierFormCodeAndNameValues';

export const ClassifierFormBreadcrumbs: FC = () => (
  <ClassifierBreadcrumbs
    data={{ classifier: useClassifierFormCodeAndNameValues() }}
  />
);
